"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/map");
var UserService = /** @class */ (function () {
    function UserService(httpWrapper, applicationPropertiesService) {
        this.httpWrapper = httpWrapper;
        this.applicationPropertiesService = applicationPropertiesService;
    }
    UserService.prototype.getById = function (userId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        var placeHolders = new Map().set("{userId}", userId.toString());
        return this.getUserServiceUrl(UserService.USER_BY_ID, placeHolders).flatMap(function (url) {
            return _this.httpWrapper.get(url)
                .catch(UserService.handleError);
        });
    };
    UserService.prototype.getUserServiceUrl = function (extension, placeHolders) {
        var _this = this;
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(UserService.UM_SERVICE_URL_KEY)
            .then(function (userServiceBase) { return userServiceBase + UserService.USER_SERVICE_BASE_PATH + extension; })
            .then(function (url) { return _this.replacePlaceholders(url, placeHolders); }))
            .catch(UserService.handleError);
    };
    UserService.prototype.replacePlaceholders = function (url, placeHolders) {
        return url.replace(/{\w+}/g, function (all) {
            return placeHolders.get(all) || all;
        });
    };
    UserService.handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error);
    };
    UserService.UM_SERVICE_URL_KEY = "um-service-url";
    UserService.USER_SERVICE_BASE_PATH = "/users";
    UserService.USER_BY_ID = "/{userId}";
    UserService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    UserService.ctorParameters = function () { return [
        { type: idm_authentication_client_js_1.HttpClientWrapper, },
        { type: idm_application_properties_service_client_js_1.ApplicationPropertiesService, },
    ]; };
    return UserService;
}());
exports.UserService = UserService;
//# sourceMappingURL=user.service.js.map